export const areArraysEqual = (a: any[] | undefined = [], b: any[] | undefined = []): boolean => {
  if (a.length != b.length) return false;
  else {
    for (let i = 0; i < a.length; i++) if (a[i] != b[i]) return false;
    return true;
  }
};
